export default "__VITE_ASSET__8a433b05__"